import { useState } from 'react';

interface Props {
  props: {
    code?: string;
    language?: string;
    filename?: string;
  };
}

export function PanelCodeBlock({ props }: Props) {
  const code = props?.code ?? '';
  const lang = props?.language ?? '';
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void navigator.clipboard?.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 6, overflow: 'hidden', margin: '4px 0' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '4px 10px',
          background: 'var(--bg-alt)',
          borderBottom: '1px solid var(--border)',
          fontSize: 11,
          color: 'var(--text-soft)',
          fontFamily: 'ui-monospace, SFMono-Regular, monospace',
        }}
      >
        <span>{props?.filename ?? lang ?? 'code'}</span>
        <button
          type="button"
          onClick={handleCopy}
          style={{
            marginLeft: 'auto',
            padding: '2px 8px',
            fontSize: 10,
            background: 'var(--surface)',
            border: '1px solid var(--border-strong)',
            borderRadius: 4,
            cursor: 'pointer',
            color: 'var(--text-soft)',
            fontFamily: 'inherit',
          }}
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <pre
        style={{
          margin: 0,
          padding: '8px 10px',
          background: 'var(--bg-alt2)',
          fontSize: 12,
          fontFamily: 'ui-monospace, SFMono-Regular, monospace',
          color: 'var(--text)',
          overflowX: 'auto',
          whiteSpace: 'pre',
          lineHeight: 1.5,
        }}
      >
        <code>{code}</code>
      </pre>
    </div>
  );
}
